<template>
  <footer class="site-footer">
    <div class="footer">
      <div class="container footer__inner">
        <div class="footer__logo">
          <div class="footer__logo-inner">
            <a href="https://www.cab.org.nz/" class="footer__cab-logo">
              <img alt="Citizens Advice Bureau" src="/images/cab-logo.svg" />
            </a>
            <router-link
              :to="{ name: 'home' }"
              class="footer__site-logo"
              v-if="logo"
            >
              <img :src="logo" :alt="$appSettings.SiteTitle + ' logo'" />
            </router-link>
          </div>
        </div>
        <div class="footer__content">
          <svg
            class="footer_shape footer_shape--desktop"
            width="96px"
            height="121px"
            viewBox="0 0 96 120"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g
                class="footer_shape-path"
                transform="translate(-827.000000, -4919.000000)"
                fill="currentColor"
              >
                <path
                  d="M857.445909,4926.30868 C857.445909,4926.30868 885.114118,4913.3016 923,4923.92127 L922.99984,5039.69531 C896.696057,5039.67899 874.045727,5039.665 871.54779,5039.66368 L871.12195,5039.66311 C869.994246,5039.65906 865.809664,5039.6301 865.192804,5039.61248 C867.504024,5039.50152 869.01077,5039.41976 870.120389,5039.20951 C875.814487,5038.03857 881.412224,5036.51577 886.688756,5034.04394 C892.965404,5031.10199 898.560221,5027.16868 903.309683,5022.08342 C908.862159,5016.13965 912.93417,5009.33886 915.292111,5001.53648 C917.327386,4994.81306 917.870515,4987.98015 917.038301,4980.99685 C916.276168,4974.60631 914.510997,4968.57787 911.027377,4963.13198 C907.808021,4958.10073 903.531607,4954.11486 898.646363,4950.69402 C893.448673,4947.05418 887.767714,4944.73566 881.457485,4944.19399 C876.302136,4943.7516 871.307389,4944.67872 866.420685,4946.41761 C861.396738,4948.20614 857.270706,4951.18021 854.099532,4955.39384 C850.754614,4959.84108 848.893081,4964.90445 848.698898,4970.49634 C848.608377,4973.14191 848.675538,4975.76411 849.272688,4978.40968 C850.119503,4982.15027 851.870073,4985.2718 854.347736,4988.13783 C857.567092,4991.86089 861.615742,4994.13415 866.333083,4995.11529 C871.002244,4996.08621 875.456781,4995.53432 879.009023,4991.91345 C880.215004,4990.68557 881.058898,4989.20657 881.051598,4987.3757 C881.048678,4986.72014 880.907055,4986.47486 880.184343,4986.6778 C878.509694,4987.14209 876.836505,4987.56258 875.053814,4987.51294 C865.57387,4987.24721 859.003756,4978.51626 860.95727,4969.77801 C861.863946,4965.7206 863.937182,4962.52315 867.477743,4960.38567 C873.411286,4956.80861 879.610553,4957.01739 885.726599,4959.7272 C892.70844,4962.81515 897.088516,4968.33697 899.261033,4975.56117 C901.256888,4982.19699 901.119645,4988.87368 898.443419,4995.28465 C894.339288,5005.11646 886.993901,5011.42085 876.662762,5014.0635 C866.559387,5016.65066 857.066303,5014.64313 848.330972,5009.32134 C839.024771,5003.65352 832.318875,4995.7285 828.960816,4985.1988 C826.929921,4978.83601 826.576595,4972.36518 827.44385,4965.76586 C828.200143,4959.98854 829.871872,4954.48279 832.479477,4949.32598 C837.431883,4939.53213 844.885312,4932.19988 854.861665,4927.4621 C855.7187,4927.05621 856.581575,4926.67223 857.445909,4926.30868 Z"
                ></path>
              </g>
            </g>
          </svg>
          <svg
            class="footer_shape footer_shape--tablet"
            width="120px"
            height="94px"
            viewBox="0 0 120 94"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g
                class="footer_shape-path"
                transform="translate(-196.000000, -4809.000000)"
                fill="currentColor"
              >
                <path
                  d="M279.277483,4808.50045 L279.114799,4808.50217 C277.532199,4808.53395 274.208138,4808.9958 273.903189,4809.06145 C270.828011,4809.71845 267.904235,4810.77145 265.058667,4812.11845 C257.038336,4815.91845 251.0464,4821.79545 247.065813,4829.64845 C244.969237,4833.78145 243.625664,4838.19745 243.017045,4842.82845 C242.321195,4848.11945 242.604949,4853.30745 244.237291,4858.40845 C246.938475,4866.85045 252.327808,4873.20445 259.808704,4877.74845 C266.831381,4882.01445 274.461675,4883.62445 282.584277,4881.55145 C290.888363,4879.43245 296.794069,4874.37645 300.092843,4866.49445 C302.245568,4861.35545 302.354859,4856.00345 300.749589,4850.68345 C299.002944,4844.89045 295.482581,4840.46345 289.870656,4837.98645 C284.953579,4835.81645 279.970325,4835.64745 275.201643,4838.51645 C272.353067,4840.22845 270.687637,4842.79245 269.958699,4846.04545 C268.388523,4853.05045 273.669568,4860.05145 281.290837,4860.26445 C282.722645,4860.30445 284.068224,4859.96745 285.414805,4859.59345 C285.995349,4859.43245 286.109653,4859.62745 286.112661,4860.15345 C286.118677,4861.62245 285.438869,4862.80745 284.470293,4863.79245 C281.614699,4866.69445 278.032171,4867.13745 274.281195,4866.35945 C270.488107,4865.57245 267.233451,4863.75045 264.646571,4860.76545 C262.654272,4858.46745 261.245525,4855.96445 260.565717,4852.96545 C260.08544,4850.84445 260.031296,4848.74245 260.104491,4846.62045 C260.260907,4842.13845 261.756885,4838.07745 264.446037,4834.51345 C266.994816,4831.13445 270.31264,4828.75145 274.350379,4827.31745 C278.277824,4825.92245 282.294507,4825.18045 286.437525,4825.53445 C291.511019,4825.96845 296.077163,4827.82645 300.256277,4830.74545 C304.18272,4833.48745 307.620864,4836.68345 310.208747,4840.71745 C313.010197,4845.08345 314.427968,4849.91645 315.040597,4855.04045 C315.709376,4860.63845 315.273216,4866.11645 313.637867,4871.50845 C311.741824,4877.76345 308.46912,4883.21545 304.006251,4887.98045 C300.186091,4892.05845 295.688128,4895.21145 290.642709,4897.56945 C287.496341,4899.04045 284.205589,4900.09145 280.84064,4900.91945 L280.84064,4900.91945 L280.82602,4900.92324 C279.863121,4901.17031 231.540483,4913.20929 196,4850.32845 L196,4850.32845 L196,4808.50045 L279.277483,4808.50045 Z"
                ></path>
              </g>
            </g>
          </svg>
          <svg
            class="footer_shape footer_shape--mobile"
            width="84px"
            height="94px"
            viewBox="0 0 84 94"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g
                class="footer_shape-path"
                transform="translate(-196.000000, -4597.000000)"
                fill="currentColor"
              >
                <path
                  d="M243.865,4597 L243.702749,4597.00172 C242.124358,4597.03349 238.809138,4597.49534 238.505,4597.561 C235.438,4598.218 232.522,4599.271 229.684,4600.618 C221.685,4604.418 215.709,4610.295 211.739,4618.148 C209.648,4622.281 208.308,4626.697 207.701,4631.328 C207.007,4636.619 207.29,4641.807 208.918,4646.908 C211.612,4655.35 216.987,4661.704 224.448,4666.248 C231.452,4670.514 239.062,4672.124 247.163,4670.051 C255.445,4667.932 261.335,4662.876 264.625,4654.994 C266.772,4649.855 266.881,4644.503 265.28,4639.183 C263.538,4633.39 260.027,4628.963 254.43,4626.486 C249.526,4624.316 244.556,4624.147 239.8,4627.016 C236.959,4628.728 235.298,4631.292 234.571,4634.545 C233.005,4641.55 238.272,4648.551 245.873,4648.764 C247.301,4648.804 248.643,4648.467 249.986,4648.093 C250.565,4647.932 250.679,4648.127 250.682,4648.653 C250.688,4650.122 250.01,4651.307 249.044,4652.292 C246.196,4655.194 242.623,4655.637 238.882,4654.859 C235.099,4654.072 231.853,4652.25 229.273,4649.265 C227.286,4646.967 225.881,4644.464 225.203,4641.465 C224.724,4639.344 224.67,4637.242 224.743,4635.12 C224.899,4630.638 226.391,4626.577 229.073,4623.013 C231.615,4619.634 234.924,4617.251 238.951,4615.817 C242.868,4614.422 246.874,4613.68 251.006,4614.034 C256.066,4614.468 260.62,4616.326 264.788,4619.245 C268.704,4621.987 272.133,4625.183 274.714,4629.217 C277.508,4633.583 278.922,4638.416 279.533,4643.54 C280.2,4649.138 279.765,4654.616 278.134,4660.008 C276.243,4666.263 272.979,4671.715 268.528,4676.48 C264.718,4680.558 260.232,4683.711 255.2,4686.069 C252.062,4687.54 248.78,4688.591 245.424,4689.419 L245.424,4689.419 L245.409419,4689.42279 C244.749665,4689.59252 221.796919,4695.32771 196.000033,4678.51248 L196.000033,4678.51248 L196,4597 L243.865,4597 Z"
                ></path>
              </g>
            </g>
          </svg>
          <div class="footer__content-inner">
            <div class="h4 footer__heading">{{ aboutHeading }}</div>
            <div class="footer__text">{{ aboutCopy }}</div>
            <nav class="footer__nav" v-if="navigation.length">
              <a
                v-for="item in navigation"
                :key="item.ID"
                :href="item.Url"
                class="footer_nav-item"
              >
                {{ item.Title }}
              </a>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import get from "lodash/get";

export default {
  data() {
    return {
      logo: null,
      aboutHeading: "",
      aboutCopy: "",
      navigation: "",
    };
  },

  created() {
    this.logo = get(this.$appSettings, "Footer.Logo", null);
    this.navigation = get(this.$appSettings, "Footer.Navigation", []);
    this.aboutHeading = get(this.$appSettings, "Footer.AboutHeading", []);
    this.aboutCopy = get(this.$appSettings, "Footer.AboutCopy", []);
  },
};
</script>

<style lang="scss">
.footer {
  background-color: var(--color-bg-footer);
}

.footer__inner {
  display: flex;
  flex-direction: column;
  padding: 0;

  @include media-breakpoint-up(xl) {
    height: rem(232px);
    flex-direction: row;
  }
}

.footer__logo {
  a {
    display: inline-block;
    margin: auto;

    @include media-breakpoint-up(sm) {
      margin: 0;
    }
  }

  img {
    display: block;
  }

  @include media-breakpoint-up(xl) {
    flex: 0 0 32%;
    position: relative;
    display: flex;
    align-items: center;
  }
}

.footer__logo-inner {
  padding: rem(35px) 0;
  display: flex;
  flex-direction: column;

  @include media-breakpoint-up(sm) {
    flex-direction: row;
    justify-content: center;
  }

  @include media-breakpoint-up(xl) {
    flex-direction: column;
  }
}

.footer__cab-logo {
  img {
    height: rem(58px);
    width: rem(227px);
    margin-bottom: rem(24px);
  }

  @include media-breakpoint-up(sm) {
    img {
      margin-bottom: 0;
      margin-right: rem(24px);
    }
  }

  @include media-breakpoint-up(xl) {
    margin-right: 0;

    img {
      height: rem(67px);
      width: rem(264px);
      margin-bottom: rem(10px);
    }
  }
}

.footer__site-logo {
  height: rem(60px);
  width: rem(226px);

  img {
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  @include media-breakpoint-up(xl) {
    height: rem(70px);
    width: rem(264px);
  }
}

.footer_shape {
  @include media-breakpoint-up(xl) {
    width: rem(193px);
    margin-top: rem(-10px);
    margin-right: rem(24px);
    height: rem(242px);
    background-color: var(--color-bg-footer);
  }

  &--desktop {
    display: none;

    @include media-breakpoint-up(xl) {
      display: block;
    }
  }

  &--tablet {
    width: rem(120px);
    height: rem(94px);
    flex: 0 0 rem(120px);
    margin-right: rem(24px);
    display: none;

    @include media-breakpoint-between(md, lg) {
      display: block;
    }
  }

  &--mobile {
    width: rem(84px);
    height: rem(94px);
    flex: 0 0 rem(84px);
    margin-right: rem(24px);

    @include media-breakpoint-up(md) {
      display: none;
    }
  }
}

.footer_shape-path {
  fill: var(--color-bg-footer);

  @include media-breakpoint-up(xl) {
    fill: var(--color-bg-footer-content);
  }
}

.footer__content {
  display: flex;
  align-items: self-start;
  justify-items: self-start;
  background-color: var(--color-bg-footer-content);

  * {
    color: var(--color-fg-footer-content);
  }

  @include media-breakpoint-up(xl) {
    position: relative;
    flex: 1 0 auto;
    margin-right: calc(50% - 50vw);
    display: flex;
    overflow: hidden;
  }
}

.footer__content-inner {
  padding-top: rem(30px);
  padding-bottom: rem(50px);
  padding-right: rem(12px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: rem(300px);

  @include media-breakpoint-up(xl) {
    width: rem(516px);
    height: 100%;
    min-height: auto;
    padding-top: rem(30px);
    padding-bottom: 0;
    padding-right: 0;
  }
}

.footer__text {
  font-size: rem(16px);
  font-weight: 300;
  letter-spacing: rem(0.24px);
  line-height: rem(28px);
  max-width: rem(456px);
}

.footer__nav {
  margin-top: rem(32px);

  @include media-breakpoint-up(xl) {
    text-align: right;
    margin-top: auto;
    margin-bottom: rem(24px);
  }
}

.footer_nav-item {
  color: var(--color-fg-footer-link);
  text-decoration: none;
  display: block;
  margin-top: rem(8px);
  font-size: rem(16px);
  font-weight: bold;
  letter-spacing: rem(0.17px);
  line-height: rem(30px);

  @include media-breakpoint-up(sm) {
    display: inline-block;
    margin-right: rem(48px);
    margin-top: 0;
  }

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin: 0;
  }

  &:active,
  &:hover {
    color: var(--color-fg-hover-footer-link);
  }

  &:hover {
    text-decoration: underline;
  }

  @include media-breakpoint-up(xl) {
    margin-left: rem(48px);
  }
}

@media print {
  .footer {
    display: none;
  }
}
</style>
